import sortBy from 'lodash/sortBy';

import { OrganizationDto } from '../dtos/OrganizationDto';
import { OrganizationsReply } from '../dtos/OrganizationsReply';
import { Organization } from '../models/Organization';

export const transformOrganizationsReply = (
  dto: OrganizationsReply,
): Organization[] => {
  const mappedOrganizations: Organization[] = dto.organizations.map(
    (dto: OrganizationDto): Organization => ({
      organizationId: dto.organizationId,

      // Some organization names contain leading or trailing spaces.
      // Trim them to avoid issues with searching and displaying.
      organizationName: dto.organizationName.trim(),
    }),
  );

  return sortBy(mappedOrganizations, (d) => d.organizationName);
};
